import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { COLORS } from "../../../../../constants";
var StepLine = function (_a) {
    var idx = _a.idx, currentStep = _a.currentStep, complete = _a.complete, previousStep = _a.previousStep;
    // these go before the bullet so none for first bullet
    if (idx === 0) {
        return null;
    }
    // if the current step is beyond this bullet or the bullet is complete, show blue to left
    if (currentStep >= idx || complete || (previousStep === null || previousStep === void 0 ? void 0 : previousStep.complete)) {
        return (_jsx(Box, { bgcolor: COLORS.SAY_COBALT, height: "2px", width: "100%", alignSelf: "center" }));
    }
    return (_jsx(Box, { bgcolor: COLORS.P_DISABLED, height: "2px", width: "100%", alignSelf: "center" }));
};
export default StepLine;
